import { Badge } from '../ui/Badge';

export interface FooterProps {
  className?: string;
}

export function Footer({ className = '' }: FooterProps) {
  return (
    <footer className={`border-t border-line bg-card/40 py-8 px-4 sm:px-6 lg:px-8 ${className}`}>
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-sub">
        {/* Left: Copyright & Branding */}
        <div className="flex flex-col sm:flex-row items-center gap-2 text-center sm:text-left">
          <span className="font-semibold text-ink">
            © 2026 DPDP Consent System
          </span>
          <span className="hidden sm:inline">•</span>
          <span>Parakrama Technologies Pvt. Ltd.</span>
        </div>

        {/* Center: Compliance Badge */}
        <div className="flex items-center gap-2">
          <Badge variant="emerald" size="sm">
            DPDP Act 2023 Compliant Infrastructure
          </Badge>
        </div>

        {/* Right: Navigation Links */}
        <div className="flex items-center space-x-6">
          <a href="#terms" className="hover:text-ink transition-colors">
            Terms of Service
          </a>
          <a href="#privacy" className="hover:text-ink transition-colors">
            Privacy Policy
          </a>
          <a href="#docs" className="hover:text-ink transition-colors">
            API Docs
          </a>
          <a href="#security" className="hover:text-ink transition-colors">
            Security & Trust
          </a>
        </div>
      </div>
    </footer>
  );
}
